
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import PartsGroupPreview from "@common/src/views/setting/components/parts-group-preview.vue";
import t from "@common/src/i18n/t";
const marketing = namespace("marketing");

@Component({ components: { PartsGroupPreview } })
export default class TestItemEdit extends Vue {
  @marketing.Action queryCardTemplateDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [
      { name: t("marketing.card-template"), path: "/marketing/card-template" },
      { name: t("marketing.template-detail") }
    ];
  }
  get checkTemplateId() {
    return this.$route.params.id;
  }
  created() {
    this.init();
  }
  cardTemplateInfo: any = {};
  groupIndex: number = 1;
  init() {
    this.queryCardTemplateDetail({
      cardTemplateCode: this.checkTemplateId
    }).then(data => {
      data = data.data;
      data.serviceList &&
        data.serviceList.forEach(serviceItem => {
          if (serviceItem.partsList && serviceItem.partsList.length > 0) {
            serviceItem.isGroup = true;
            serviceItem.groupServiceIndex = this.groupIndex;
            serviceItem.partsList.forEach(partsItem => {
              data.partsList.push(
                Object.assign(partsItem, {
                  isGroup: true,
                  groupServiceIndex: this.groupIndex
                })
              );
            });
            this.groupIndex++;
          }
        });
      this.cardTemplateInfo = data;
    });
  }
  showPartsGroupPreview = false;
  partsRuleCode = "";
  partsRuleType = 2;
  groupName = "";
  handleGroupDetail(row) {
    this.showPartsGroupPreview = true;
    this.partsRuleCode = row.partsCode;
    this.partsRuleType = row.partsRuleType;
    this.groupName = row.partsName;
  }
}
